module.exports = __webpack_public_path__ + "static/media/ZNOG_110.85d53118.png";